<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1 class="ws-page-header__title has-text-weight-bold is-size-2" v-text="$t('Создание ЦПДЭ')"></h1>
    </header>
    <section class="ws-page-content">
      <form class="ws-form" @submit.prevent="submit">
        <header class="ws-form__header">
          <h2 class="is-size-2 has-text-primary" v-text="$t('Общие данные')"></h2>
          <div class="divider"></div>
        </header>
        <div class="ws-form__content">
          <div class="columns is-multiline">
            <div class="column is-12">
              <b-field class="ws-field"
                       :label="$t('Наименование ЦПДЭ (в системе)')"
                       :type="{'is-danger': errors.has('name')}"
                       :message="errors.first('name')">
                <ws-refbook-field
                        name="name"
                        entity="de-centers"
                        field="name.display"
                        v-model="newItem.name.translate.ru"
                        v-validate="{ required: true }"
                        :isFocus="true">
                  <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                </ws-refbook-field>
              </b-field>
            </div>
            <div class="column is-12">
              <b-field class="ws-field"
                       :label="$t('Адрес')"
                       :type="{'is-danger': errors.has('address')}"
                       :message="errors.first('address')">
                <b-autocomplete
                        class="ws-field__control"
                        name="address"
                        field="value"
                        @select="selectAddress"
                        @keyup.native="getAddressList"
                        @focus="getAddressList"
                        v-validate="{ required: true }"
                        v-model="address.value"
                        :loading="isAddressPending"
                        :data="address.list">
                  <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                </b-autocomplete>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field class="ws-field" :label="$t('Регион')">
                <ws-refbook-field
                        entity="public/refbook/region"
                        field="title.display"
                        v-model="region.value"
                        :guid.sync="region.guid"
                        :params="{country: config.default_country_code}"
                        @change="selectRegion"
                        :isFocus="true">
                  <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                </ws-refbook-field>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field class="ws-field"
                       :label="$t('Район')"
                       :type="{'is-danger': errors.has('district')}"
                       :message="errors.first('district')">
                <ws-refbook-field
                        entity="public/refbook/district"
                        field="title.display"
                        v-model="district.value"
                        :guid.sync="district.guid"
                        :params="{country: config.default_country_code}"
                        @change="selectDistrict"
                        :isFocus="true">
                  <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                </ws-refbook-field>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field class="ws-field"
                       :label="$t('Населенный пункт')"
                       :type="{'is-danger': errors.has('locality')}"
                       :message="errors.first('locality')">
                <ws-refbook-field
                        entity="public/refbook/locality"
                        field="title.display"
                        v-model="locality.value"
                        :guid.sync="locality.guid"
                        :params="{country: config.default_country_code}"
                        @change="selectLocality"
                        :isFocus="true">
                  <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                </ws-refbook-field>
              </b-field>
            </div>
            <div class="column is-8">
              <p v-text="$t('Является Экзаменационным центром для проведения профессионального экзамена (НОК)')"></p>
            </div>
            <div class="column is-1">
              <div class="field">
                <b-radio v-model="newItem.prof_exam_center"
                         :native-value="true">
                  {{ $t('Да') }}
                </b-radio>
              </div>
            </div>
            <div class="column is-1">
              <b-radio v-model="newItem.prof_exam_center"
                       :native-value="false">
                {{ $t('Нет') }}
              </b-radio>
            </div>
          </div>
        </div>
        <div class="ws-form__footer">
          <div class="columns">
            <div class="column is-9"></div>
            <div class="column is-3 is-vcentered">
              <div class="has-text-right-desktop">
                <button class="ws-button button is-large is-primary is-fullwidth"
                        :class="{'is-loading': isCreatePending }"
                        :disabled="isCreatePending">
                  <span class="is-size-4 has-text-weight-bold" v-text="$t('Создать ЦПДЭ')"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'debounce'

export default {
  name: 'DeCenterNew',
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          name: {
            display: '',
            translate: {
              ru: '',
              en: ''
            }
          },
          region: {
            guid: null,
            title: {
              translate: {
                ru: ''
              }
            }
          },
          district: {
            guid: null,
            title: {
              translate: {
                ru: ''
              }
            }
          },
          locality: {
            guid: null,
            title: {
              translate: {
                ru: ''
              }
            }
          },
          address: {
            translate: {
              ru: ''
            }
          },
          prof_exam_center: false
        }
      }
    }
  },
  watch: {
    item: {
      deep: true,
      handler (item) {
        this.newItem = item
      }
    },
    district: {
      deep: true,
      handler (item) {
        this.newItem.district.title.translate.ru = item.value
      }
    },
    locality: {
      deep: true,
      handler (item) {
        this.newItem.locality.title.translate.ru = item.value
      }
    }
  },
  data () {
    return {
      config: __config,
      newItem: this.item,
      isAddressPending: false,
      region: {
        value: '',
        guid: null
      },
      district: {
        value: '',
        guid: null
      },
      locality: {
        value: '',
        guid: null
      },
      address: {
        value: '',
        guid: null
      }
    }
  },
  computed: {
    ...mapState('de-centers', {
      isCreatePending: 'isCreatePending'
    }),
    ...mapState('public/refbook/region', {
      isRegionPending: 'isFindPending'
    }),
    ...mapState('public/refbook/district', {
      isDistrictPending: 'isFindPending'
    }),
    ...mapState('public/refbook/locality', {
      isLocalityPending: 'isFindPending'
    })
  },
  methods: {
    ...mapActions('de-centers', ['create']),
    ...mapActions('public/refbook/region', {
      findRegion: 'find',
      getAddress: 'getAddress'
    }),
    ...mapActions('public/refbook/district', {
      findDistrict: 'find'
    }),
    ...mapActions('public/refbook/locality', {
      findLocality: 'find'
    }),
    getFormattedAddress (data) {
      const address = []

      if (data.settlement_type === 'мкр') {
        address.push(data.settlement_with_type)
      }

      if (data.street_with_type) {
        address.push(data.street_with_type)
      }

      let addr = ''

      if (data.house_type) {
        addr += `${data.house_type} ${data.house}`
      }

      if (data.block_type) {
        addr += ` ${data.block_type} ${data.block}`
      }

      if (data.flat_type) {
        addr += ` ${data.flat_type} ${data.flat}`
      }

      address.push(addr)

      return address.join(', ')
    },

    selectRegion (region) {
      this.newItem.region.guid = region.guid
      this.region.guid = region.guid
    },
    selectDistrict (district) {
      if (district) {
        this.district.guid = district.guid
        this.newItem.district.guid = district.guid
      } else {
        this.newItem.district = {
          title: {
            translate: {
              ru: this.district.value
            }
          }
        }
      }
    },
    selectLocality (locality) {
      this.locality.guid = locality && locality.guid ? locality.guid : ''
    },
    async selectAddress (address) {
      if (address) {
        const details = address.data
        this.region.value = details.region
        this.district.value = details.city_district_with_type
        this.locality.value = details.city_with_type
        this.region.value = details.region
        const [ region ] = await this.findRegion({
          params: { country: __config.default_country_code },
          query: { k: this.region.value }
        })

        this.region.value = region.title.display
        this.newItem.region.guid = region.guid
        this.newItem.locality = {
          title: {
            translate: {
              ru: details.city_with_type
            }
          }
        }
        this.newItem.district = {
          title: {
            translate: {
              ru: details.city_district_with_type
            }
          }
        }
        this.address.value = this.getFormattedAddress(details)
        this.newItem.address = {
          translate: {
            ru: this.address.value
          }
        }
      }
    },
    getAddressList: debounce(async function () {
      const query = this.address.value
      this.isAddressPending = true
      const list = await this.getAddress({
        query: query
      })
      this.isAddressPending = false
      this.address.list = list
    }, 500),
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          try {
            this.create({
              address: this.newItem,
              name: this.newItem.name,
              prof_exam_center: this.newItem.prof_exam_center
            })
            this.$buefy.toast.open({
              message: this.$t(`ЦПДЭ ${this.newItem.name.translate.ru} успешно создан`),
              type: 'is-success'
            })
            this.$router.push('/de-center')
          } catch (e) {
            this.$buefy.toast.open({
              message: this.$t(`Что-то пошло не так.`),
              type: 'is-danger'
            })
          }
        }
      })
    }
  },
  async mounted () {
  }
}
</script>
